<script>
export default {
  name: 'RTDispersionConfirmation',
  components: {},
  methods: {
    clicked() {},
  },
}
</script>

<template>
  <b-container
    class="container"
    fluid
  >
    <b-row class="justify-content-md-center">
      <b-col
        sm="11"
        lg="6"
      >
        <h2>{{ $t('WIDGETS.RT_DISPERSION.CONFIRMATION') }}</h2>
      </b-col>
    </b-row>

    <b-row align-h="center">
      <b-col
        sm="8"
        lg="4"
      >
        <b-img
          :src="require('@/assets/images/logo.png')"
          fluid-grow
          alt="Fluid-Grow image"
        />
      </b-col>
    </b-row>

    <b-row align-h="center">
      <b-col
        sm="8"
        lg="4">
        <p class="text">
          {{ $t('WIDGETS.RT_DISPERSION.IN_REVISION') }}
        </p>
      </b-col>
    </b-row>

    <b-row align-h="center">
      <b-col
        sm="6"
        md="6"
        lg="4">
        <BaseButton
          @click="clicked()"
        >
          {{ $t('WIDGETS.COMMON.UNDERSTOOD') }}
        </BaseButton>
      </b-col>
    </b-row>

  </b-container>
</template>


<style scoped lang="scss">
.input {
  height: 70px;
  text-align: center;
  border: 2px solid #4fb296;
  border-radius: 64px;
}

.text {
  font-size: 1.2rem;
}

.container {
  padding: 2rem;
  // background-color: burlywood;
}

.col {
  // background-color: aqua;
}

.row {
  margin: 0.5rem;
  // background-color: red;
}

h2 {
  font-weight: bold;
}
</style>
